/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indexesList } from "../../funcs/indexesList.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$indexesList: ToolDefinition = {
  name: "indexes-list",
  description: `List indexes within a project

Retrieve a list of all created indexes.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await indexesList(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
